import { RouteInterface } from "../../common";
import { AppRouter, AppRouting, AppRoutingAdditional, AppRoutingAdditionalCrossell, ROOT_PATH_APP } from "../app";

export const MainRouting = (): Array<RouteInterface> => [
  {
    path: ROOT_PATH_APP,
    element: AppRouter,
    functions: [],
    children: [...AppRouting, ...AppRoutingAdditional, ...AppRoutingAdditionalCrossell]
  }
];